import type {
  ApiEventId,
  ApiInternshipId,
  ApiJobId,
  ApiOrgId,
  ApiVolopId,
} from '#/api/types/ApiTypedId';
import {
  orgDashboardRepostEventRoute,
  orgDashboardRepostInternshipRoute,
  orgDashboardRepostJobRoute,
  orgDashboardRepostVolopRoute,
} from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { ListingType } from '#/types/ListingType';

type Args = {
  orgId: ApiOrgId;
  listingId: ApiJobId | ApiInternshipId | ApiVolopId | ApiEventId;
  listingType: Exclude<ListingType, 'ORG'>;
};

export function orgDashboardGetRepostListingPathSwitch({
  orgId,
  listingId,
  listingType,
}: Args) {
  switch (listingType) {
    case 'JOB':
      return orgDashboardRepostJobRoute.with({ orgId, jobId: listingId });
    case 'INTERNSHIP':
      return orgDashboardRepostInternshipRoute.with({
        orgId,
        internshipId: listingId,
      });
    case 'VOLOP':
      return orgDashboardRepostVolopRoute.with({
        orgId,
        volopId: listingId,
      });
    case 'EVENT':
      return orgDashboardRepostEventRoute.with({
        orgId,
        eventId: listingId,
      });
  }
}
